module.exports = __webpack_public_path__ + "img/warning-sign-svgrepo-com.5f853e4e.svg";